import React from 'react'
import { LayoutContainer, LayoutForm,HeroImage,ImageSide} from './styled';
import AUTHIMAGE from '../../../../assets/images/authImage.jpg';

const EntryLayout = ({ children,backgroundImage=AUTHIMAGE }) =>{
  return (
    <LayoutContainer>
      <ImageSide>
        <HeroImage src={backgroundImage} alt="Hero background"/>
      </ImageSide>
      <LayoutForm>{children}</LayoutForm>
    </LayoutContainer>
  );
};

export default EntryLayout;
